import {Recommendation} from "../../../services/models/recommendation";
import s from "./styles.module.css";
import sButtons from "../../../assets/styles/buttons.module.css";
import React, {useState} from "react";
import RecommendationModal, {FormValues} from "./RecommendationModal";
import DeleteRecommendationModal from "./DeleteRecommendationModal";
import {useDeleteRecom} from "../../../hooks/useQuery/useDeleteRecom";
import {useUpdateRecom} from "../../../hooks/useQuery/useUpdateRecom";
import {useParams} from "react-router-dom";
import {SubUser} from "../../../services/models/sub_user";

interface NewRecommendationCardProps {
    recommendation: Recommendation;
    handleLinkClick: (id: string) => void;
    subUsersSectorData?: Partial<SubUser>[];
}

const NewRecommendationCard = ({
                                   recommendation,
                                   handleLinkClick,
                                   subUsersSectorData = []
                               }: NewRecommendationCardProps) => {
    const {name, id, status, goal, sector, text, in_charge, deadline, description} = recommendation as any;
    const {sectorId} = useParams();
    const {mutate: deleteRecom} = useDeleteRecom(sectorId as string);

    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState<string | null>(null);
    const {mutate: updateRecom} = useUpdateRecom();

    const handleEdit = () => {
        setShowEditModal(true);
    };

    const handleSave = (data: FormValues, file: File | null) => {
        const {id: recomId, ...updateFields} = data;
        updateRecom({
            id: recomId || id,
            data: {
                ...updateFields,
                file: file || undefined
            }
        }, {
            onSuccess: () => {
                setShowEditModal(false);
            }
        });
    };


    const handleDeleteRequest = (deleteId: string) => {
        console.log(deleteId);
        setDeleteId(deleteId);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirmed = () => {
        if (deleteId) {
            deleteRecom(deleteId, {
                onSuccess: () => {
                    setShowDeleteModal(false);
                    setShowEditModal(false);
                    setDeleteId(null);
                }
            });
        }
    };


    return (
        <>
            <div className={`d-flex flex-column ${s.wrapper}`}>
                <div className={s.content}>
                    <div className={s.header}>
                        <div className={s.infoBlock}>
                            <div className={s.roleWrapper}>
                                <p className={s.role}>
                                    Статус: {status}
                                </p>
                            </div>
                        </div>
                    </div>
                    <h3 className={s.title}>{name}</h3>
                </div>
                <div className={s.buttons}>
                    <button
                        onClick={() => handleLinkClick(id)}
                        className={`${sButtons.iconButton} ${s.button} ${sButtons.redirectButtonRight}`}
                    >
                        {recommendation.unreadCommentsCount !== 0 && (
                            <span className={s.unreadCount}>{recommendation.unreadCommentsCount}</span>
                        )}
                        <span>Перейти</span>
                    </button>
                    <button
                        onClick={handleEdit}
                        className={`${sButtons.iconButton} ${s.button} ${sButtons.settingsButtonRight} ${sButtons.lightBlueButton}`}
                    >
                        Изменить
                    </button>
                </div>
            </div>
            <RecommendationModal
                show={showEditModal}
                onClose={() => setShowEditModal(false)}
                onSave={handleSave}
                onDelete={handleDeleteRequest}
                isEdit={true}
                initialValues={{
                    name: name || '',
                    text: description || text || '',
                    deadline: deadline || '',
                    goal: goal || '',
                    in_charge: in_charge || '',
                    id: id || ''
                }}
                subUsersSectorData={subUsersSectorData}
            />
            <DeleteRecommendationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                onDelete={handleDeleteConfirmed}
                recommendationName={name}
            />
        </>
    );
};

export default NewRecommendationCard;
